import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronsUpDownIcon } from 'lucide-react';
import { clusters, phenotypeCue, phenotypeHeadline, phenotypeSupport } from '../../data/teaser';
import { ClusterImage } from '../ClusterImage';
const EASE = [0.23, 1, 0.32, 1] as const;
export function PhenotypesScreen() {
  const [index, setIndex] = useState(0);
  const active = clusters[index];
  const move = (delta: number) => setIndex(i => Math.min(clusters.length - 1, Math.max(0, i + delta)));
  return <div className="flex flex-1 flex-col" data-id="element-116" data-mp="1q3qla31uwjjz">
      <motion.h2 initial={{
      opacity: 0,
      y: 8
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.26,
      ease: EASE
    }} className="font-display text-[26px] font-bold uppercase leading-[0.98] tracking-tight text-navy" data-id="element-117" data-mp="1c2nyfo31f580">
        {phenotypeHeadline[0]}
        <span className="mt-1 block text-blue" data-id="element-118" data-mp="3bfi9zz61vf77">{phenotypeHeadline[1]}</span>
      </motion.h2>

      <p className="mt-2.5 text-[12px] leading-relaxed text-mut" data-id="element-119" data-mp="2cnyofjhsgdh0">{phenotypeSupport}</p>

      <div className="mt-4 flex flex-1 gap-3" data-id="element-120" data-mp="2cllx4fq54qra">
        {/* Vertical cluster slider — makes the four phenotypes explicitly steppable */}
        <div className="flex shrink-0 flex-col items-center gap-1.5" role="tablist" aria-orientation="vertical" aria-label="DME phenotype clusters" data-id="element-121" data-mp="2lgs9xyntw93b">
          {clusters.map((c, i) => {
          const isActive = i === index;
          return <button key={c.id} type="button" role="tab" aria-selected={isActive} onClick={() => setIndex(i)} className={`flex w-8 flex-1 flex-col items-center justify-center gap-1 rounded-lg border text-[10px] font-bold tabular-nums transition-colors duration-150 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue ${isActive ? 'border-blue bg-blue text-paper' : 'border-line bg-mist text-mut hover:border-blue'}`} data-id="element-122" data-mp="1oqrlk0rdfumj" data-mpi={i}>
                <span className="text-[8px] font-medium uppercase tracking-micro opacity-70" data-id="element-123" data-mp="2bq6yfux6j41e">
                  CL
                </span>
                {i + 1}
              </button>;
        })}
          <ChevronsUpDownIcon className="mt-0.5 h-3.5 w-3.5 text-blue" aria-hidden="true" data-id="element-124" data-mp="2kqwoehzre077" />
        </div>

        <motion.div drag="y" dragConstraints={{
        top: 0,
        bottom: 0
      }} dragElastic={0.12} onDragEnd={(_, info) => {
        if (info.offset.y < -40) move(1);
        if (info.offset.y > 40) move(-1);
      }} className="min-w-0 flex-1 cursor-grab active:cursor-grabbing" data-id="element-125" data-mp="1o3idf0cvivgk">
          <AnimatePresence mode="wait" data-id="element-126" data-mp="14dy5ds4m1r9l">
            <motion.article key={active.id} initial={{
            opacity: 0,
            y: 14
          }} animate={{
            opacity: 1,
            y: 0
          }} exit={{
            opacity: 0,
            y: -10
          }} transition={{
            duration: 0.24,
            ease: EASE
          }} className={`overflow-hidden rounded-xl border bg-paper ${active.advanced ? 'border-band/40' : 'border-line'}`} data-id="element-127" data-mp="14cwr7esasonn">
              <ClusterImage cluster={active} className="aspect-[16/10]" data-id="element-128" data-mp="rtj2vzyj83ah" />
              <div className="px-3 py-3" data-id="element-129" data-mp="nspgxc4ngyk8">
                <p className="font-display text-[15px] font-bold uppercase tracking-tight text-navy" data-id="element-130" data-mp="nw3gkclxitnz">
                  {active.name}
                </p>
                <p className="mt-0.5 text-[12px] leading-tight text-mut" data-id="element-131" data-mp="e2wd4xar1nqj">{active.descriptor}</p>
                <p className="mt-2.5 border-t border-line pt-2.5 text-[11px] leading-snug text-navy2" data-id="element-132" data-mp="95w72mdwgkzf">
                  {active.signature}
                </p>
              </div>
            </motion.article>
          </AnimatePresence>

          <p className="mt-2 text-center text-[9px] uppercase tracking-micro text-mut" data-id="element-133" data-mp="695o0l67f6d">
            Swipe or tap CL 1–4 · {index + 1} of {clusters.length}
          </p>
        </motion.div>
      </div>

      <p className="mt-3 text-[9px] uppercase tracking-micro text-mut" data-id="element-134" data-mp="1v9fliytnyvw4">{phenotypeCue}</p>
    </div>;
}